import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class SetupErrorBoundary extends React.Component<Props, State> {
  state = { hasError: false };
  
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  
  render() {
    if (this.state.hasError) {
      return (
        <div className="bg-white rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold text-red-600">
            Error Loading Setup
          </h3>
          <p className="mt-2 text-gray-600">
            There was an error loading the setup page. Please try refreshing.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}